<script>
	import { model } from "../../../stores";

	import AddressAutoComplete from "../../../components/AddressAutoComplete.svelte";
	import Input from "../../../components/Input.svelte";
	import Checkbox from "../../../components/Checkbox.svelte";
	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";

	import Declaration from "./Declaration.svelte";
	import ClaimantDetails from "./ClaimantDetails.svelte";
	import Signature from "./Signature.svelte";

	export let disabled = null;
	export let stage = null;
	export let directorName = null;
	export let executorName = null;
	export let poaName = null;
	export let solicitorName = null;

	switch ($model.OptOut.OptOutType) {
		case "Director":
			directorName = $model.Claimant.Surname;
			break;
		case "Executor":
			executorName = $model.Claimant.Surname;
			break;
		case "Power of Attorney":
			poaName = $model.Claimant.Surname;
			break;
		case "Solicitor":
			solicitorName = $model.Claimant.Surname;
			break;
	}

	$: contactName = `${$model.Contact.FirstName || ""} ${$model.Contact.Surname || ""}`;
</script>

<FormRow>
	<FormColumn cols="6">
		<label for="contact-firstName" class="isrequired">First Name</label>
		<input
			required
			{disabled}
			type="text"
			bind:value={$model.Contact.FirstName}
			id="contact-firstName"
			class="form-control"
		/>
	</FormColumn>
	<FormColumn cols="6">
		<label for="contact-surname" class="isrequired">Surname</label>
		<input
			required
			{disabled}
			type="text"
			bind:value={$model.Contact.Surname}
			id="contact-surname"
			class="form-control"
		/>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="6">
		<label for="contact-phone" class="isrequired">Phone Number</label>
		<input
			required
			{disabled}
			type="text"
			bind:value={$model.Contact.PhoneNumber}
			id="contact-phone"
			class="form-control"
			phone
		/>
	</FormColumn>
	<FormColumn cols="6">
		<label for="contact-email" class="isrequired">Email Address</label>
		<input
			required
			{disabled}
			type="email"
			bind:value={$model.Contact.EmailAddress}
			id="contact-email"
			class="form-control"
		/>
	</FormColumn>
</FormRow>

<AddressAutoComplete
	idPrefix="contact"
	bind:googlePlaceJson={$model.Contact.Address.GooglePlaceJson}
	bind:formattedAddress={$model.Contact.Address.FormattedAddress}
	bind:premise={$model.Contact.Address.Premise}
	bind:subpremise={$model.Contact.Address.Subpremise}
	bind:street={$model.Contact.Address.Street}
	bind:suburb={$model.Contact.Address.Suburb}
	bind:state={$model.Contact.Address.State}
	bind:postcode={$model.Contact.Address.Postcode}
	bind:country={$model.Contact.Address.Country}
	bind:lat={$model.Contact.Address.Lat}
	bind:lng={$model.Contact.Address.Lng}
	bind:placeId={$model.Contact.Address.PlaceId}
	bind:url={$model.Contact.Address.GoogleMapsUrl}
	{disabled}
	required
></AddressAutoComplete>

<Declaration
	{disabled}
	{contactName}
	bind:directorName
	bind:executorName
	bind:poaName
	bind:solicitorName
	bind:optOutType={$model.OptOut.OptOutType}
/>

{#if $model.OptOut.OptOutType && $model.OptOut.OptOutType != "Group Member"}
	<ClaimantDetails {disabled} bind:claimant={$model.Claimant} />
{/if}

{#if stage === "review"}
	<Signature
		{stage}
		bind:signature={$model.OptOut.Signature}
		bind:dateSignature={$model.OptOut.DateSignature}
		bind:consent={$model.OptOut.Consent}
	/>
{/if}
